import { SVGProps } from 'react'
const LeftSessionsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={62}
    height={62}
    fill="none"
    {...props}
  >
    <circle cx={31.125} cy={31.197} r={30.625} fill="#CBFFE0" />
    <path
      fill="#06C755"
      d="M42.96 22.146c-.397-.39-.833-.584-1.389-.584h-1.944v-1.44c0-.662-.238-1.207-.714-1.713a2.42 2.42 0 0 0-1.746-.701h-.992c-.675 0-1.23.234-1.746.7a2.328 2.328 0 0 0-.715 1.714v1.44h-5.873v-1.44c0-.662-.238-1.207-.714-1.713a2.42 2.42 0 0 0-1.746-.701h-.992c-.675 0-1.23.234-1.746.7a2.328 2.328 0 0 0-.714 1.714v1.44h-1.945c-.516 0-.992.195-1.389.584-.397.39-.595.818-.595 1.363V42.74c0 .506.198.973.595 1.362.397.39.834.584 1.39.584h21.547c.516 0 .992-.194 1.389-.584.396-.39.595-.817.595-1.362V23.509c.04-.545-.159-.974-.556-1.363Zm-7.262-1.518h1.945v2.997h-1.945v-2.997Zm-11.746 0h1.945v2.997h-1.945v-2.997Zm17.62 22.074H20.023V27.324H41.57v15.378Z"
    />
    <circle cx={24.563} cy={30.833} r={0.729} fill="#06C755" />
    <path
      stroke="#06C755"
      strokeLinecap="round"
      strokeWidth={0.729}
      d="M26.021 30.833h10.938"
    />
    <circle cx={24.563} cy={33.75} r={0.729} fill="#06C755" />
    <path
      stroke="#06C755"
      strokeLinecap="round"
      strokeWidth={0.729}
      d="M26.021 33.75h10.938"
    />
    <path fill="#06C755" d="M23.834 35.937h1.458v1.458h-1.458z" />
    <path
      stroke="#06C755"
      strokeLinecap="round"
      strokeWidth={0.729}
      d="M26.021 36.666h10.938"
    />
    <path fill="#06C755" d="M23.834 38.853h1.458v1.458h-1.458z" />
    <path
      stroke="#06C755"
      strokeLinecap="round"
      strokeWidth={0.729}
      d="M26.021 39.583h10.938"
    />
  </svg>
)
export default LeftSessionsIcon
